import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetEuropaceProcessData =
    LoanRequestsTableDefinitionZod.shape.europace.nullable();

export type SchemaLoanRequestResolver_GetEuropaceProcessData = z.infer<
    typeof schemaLoanRequestResolver_GetEuropaceProcessData
>;

export type LoanRequestResolver_GetEuropaceProcessData = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetEuropaceProcessData
>;
